module.exports = __webpack_public_path__ + "img/WRC03.3503cfb7.png";